import { MuiThemeProvider } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import podAxios from '../../axios-pod';
import theme from '../../components/Theme/theme';
import MyHeader from '../../components/UI/MyHeader/MyHeader';
import IngestPod from '../../containers/IngestPod/IngestPod';
import PlaylistPod from '../../containers/PlaylistPod/PlaylistPod';
import PlayoutPod from '../../containers/PlayoutPod/PlayoutPod';
import { IScreen, IState, IUser } from '../../models/states';
import { fetchFeeds } from '../../store/actions/feedActions';
import { fetchScreens } from '../../store/actions/screenActions';
import { fetchUsers } from '../../store/actions/userActions';
import { ScreenType } from '../../utilities/utilities';
import withErrorHandler from '../../utilities/withErrorHandler';
import axios from './../../axios-pod';
export const ThemeContext = React.createContext('light');

class Layout extends React.Component<ILayoutProps, ILayoutState> {
  constructor(props: ILayoutProps) {
    super(props);
    this.state = {
      theme: 'dark'
    };
  }
  componentDidMount() {
    const { user } = this.props;
    if (user) {
      this.props.fetchFeeds();
      this.props.fetchScreens(this.props.user.userId);
      this.props.fetchUsers();
    }
  }
  componentWillMount() {
    podAxios.defaults.baseURL = globalThis.UI_CONFIG.backend_url;
    const uiTheme = localStorage.getItem('theme');
    if (uiTheme) {
      this.setState({ theme: uiTheme });
    } else {
      localStorage.setItem('theme', 'dark');
    }
  }
  handleChangeTheme = () => {
    const uiTheme = this.state.theme === 'light' ? 'dark' : 'light';
    this.setState({ theme: uiTheme });
    localStorage.setItem('theme', uiTheme);
  };
  render() {
    let renderedComponent = this.props.renderedComponent;
    if (!renderedComponent && this.props.selectedScreen) {
      switch (this.props.screenMap[this.props.selectedScreen].type) {
        case ScreenType.INGEST:
          renderedComponent = <IngestPod />;
          break;
        case ScreenType.PLAYLIST:
          renderedComponent = <PlaylistPod />;
          break;
        case ScreenType.PLAYOUT:
          renderedComponent = <PlayoutPod />;
          break;
        case 'monitor':
          break;
      }
    }
    return (
      <MuiThemeProvider theme={theme(this.state.theme)}>
        <ThemeContext.Provider value={this.state.theme}>
          <MyHeader onChangeTheme={this.handleChangeTheme} />
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              backgroundColor:
                this.state.theme === 'dark' ? '#333333' : '#f0f0f0'
            }}
          >
            <div
              style={{
                position: 'relative',
                width: '100%',
                minHeight: '100vh',
                backgroundColor:
                  this.state.theme === 'dark' ? '#333333' : '#f0f0f0'
              }}
            >
              {renderedComponent}
            </div>
          </div>
        </ThemeContext.Provider>
      </MuiThemeProvider>
    );
  }
}
interface ILayoutOwnProps {
  renderedComponent: any;
}
interface ILayoutState {
  theme: string;
}
interface ILayoutStateProps {
  user: IUser;
  screenMap: { [key: string]: IScreen };
  selectedScreen: string;
  screenIds: string[];
}
interface ILayoutDispatchProps {
  fetchFeeds: () => any;
  fetchScreens: (userId: string) => any;
  fetchUsers: () => any;
}
type ILayoutProps = ILayoutOwnProps & ILayoutStateProps & ILayoutDispatchProps;

const mapStateToProps = (state: IState) => {
  return {
    user: state.user.userInfo,
    screenMap: state.screens.screenMap,
    selectedScreen: state.screens.selectedScreen,
    screenIds: state.screens.screenIds
  };
};

const mapDispatchToProps: ILayoutDispatchProps = {
  fetchFeeds,
  fetchScreens,
  fetchUsers
};
export default connect<
  ILayoutStateProps,
  ILayoutDispatchProps,
  ILayoutOwnProps
>(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(Layout, axios));
